import { render, staticRenderFns } from "./KSRNewVehicle.vue?vue&type=template&id=57dd0bc3&"
import script from "./KSRNewVehicle.vue?vue&type=script&lang=js&"
export * from "./KSRNewVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports